var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTkt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 17,
    viewBox: "0 0 71 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3312 0H0V4.84245C1.88506 4.84245 3.4089 6.36629 3.4089 8.25135C3.4089 10.1364 1.88506 11.6603 0 11.6603V16.514H40.3312",
    fill: "#009DF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3312 16.514H71V11.6603C69.115 11.6603 67.5911 10.1364 67.5911 8.25135C67.5911 6.36629 69.115 4.84245 71 4.84245V0H40.3312",
    fill: "#FF005F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9536 14.3694H8.64631V5.07959H6.82898V2.14478H13.8387V5.07959H11.9423V14.3694H11.9536Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6523 14.3694H21.0854L18.8955 8.73682L18.9858 14.3694H15.6898V2.14478H18.9858L18.8955 7.38229L20.8483 2.14478H24.3362L21.6949 8.04827L24.6523 14.3694Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5492 14.3694H28.2419V5.07959H26.4246V2.14478H33.4343V5.07959H31.5379V14.3694H31.5492Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6752 7.3032H56.2806V7.81115C56.2806 10.1703 55.9307 11.8635 55.2309 12.8906C54.4633 14.0194 53.3345 14.5838 51.8333 14.5838C50.3546 14.5838 49.2032 14.0307 48.3679 12.9245C47.5326 11.807 47.115 10.2719 47.115 8.3191C47.115 6.34374 47.5326 4.77475 48.3792 3.63468C49.2145 2.49462 50.3659 1.91895 51.822 1.91895C53.7522 1.91895 55.1519 2.92356 56.021 4.94406L52.8266 6.11799C52.7814 5.73421 52.6686 5.42944 52.4992 5.20368C52.3299 4.97793 52.1155 4.86505 51.8559 4.86505C50.9528 4.86505 50.49 6.11799 50.49 8.61258C50.49 9.67363 50.5916 10.4412 50.7948 10.9266C50.998 11.4119 51.314 11.649 51.7543 11.649C51.9236 11.649 52.0816 11.6038 52.2283 11.5248C52.3751 11.4458 52.488 11.3216 52.5896 11.1636C52.6911 11.0056 52.7589 10.825 52.8153 10.6105C52.8717 10.396 52.8943 10.1477 52.8943 9.87681H51.6752V7.3032Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0415 14.3694V2.14478H64.1708V5.02315H61.3375V6.80662H63.8886V9.57212H61.3488V11.4459H64.182V14.3807H58.0415V14.3694Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3313 11.6603C42.2139 11.6603 43.7402 10.1341 43.7402 8.25143C43.7402 6.36875 42.2139 4.84253 40.3313 4.84253C38.4486 4.84253 36.9224 6.36875 36.9224 8.25143C36.9224 10.1341 38.4486 11.6603 40.3313 11.6603Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkt);
export default __webpack_public_path__ + "static/media/tkt.92f827e4181a29849aaa4e05d754ebdd.svg";
export { ForwardRef as ReactComponent };